import * as yup from "yup";

export const validationSchema = () =>
  yup.object().shape({
    companyName: yup
      .string()
      .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
      .required("Bu xana tələb olunur."),
    // directorFullName: yup
    //   .string()
    //   .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
    //   .required("Bu xana tələb olunur."),
    // companyVoen: yup
    //   .string()
    //   .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
    //   .required("Bu xana tələb olunur."),
    // bankName: yup
    //   .string()
    //   .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
    //   .required("Bu xana tələb olunur."),
    // correspondentAccount: yup
    //   .string()
    //   .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
    //   .required("Bu xana tələb olunur."),
    // bankVoen: yup
    //   .string()
    //   .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
    //   .required("Bu xana tələb olunur."),
    // bankCode: yup
    //   .string()
    //   .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
    //   .required("Bu xana tələb olunur."),
    // swift: yup
    //   .string()
    //   .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
    //   .required("Bu xana tələb olunur."),
    // settlementAccount: yup
    //   .string()
    //   .min(3, "Mininum 3 hərfdən ibarət olmalıdır.")
    //   .required("Bu xana tələb olunur."),
  });
